import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import ReactGA from "react-ga4";

export default function LandingPage() {
  const navigate = useNavigate();
  const { session } = useAuth();

  return (
    <div className="homepage">
      <div className="links-container">
        <button
          className="link-button"
          onClick={() => {
            ReactGA.event({
              category: "Landing",
              action: "Click Browse Button"
            });
            navigate("/browse")}}
        >
          Browse
        </button>

        {!session && (
          <button
            className="link-button"
            onClick={() => {
              ReactGA.event({
                category: "Landing",
                action: "Click Create Account Button"
              });
              navigate("/login?view=sign_up")}}
          >
            Create Account
          </button>
        )}
      </div>
    </div>
  );
}
